import { render } from "./besoinsVue.vue?vue&type=template&id=52b6568e"
import script from "./besoinsVue.vue?vue&type=script&lang=js"
export * from "./besoinsVue.vue?vue&type=script&lang=js"

import "../assets/css/besoin.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__